module.exports = __webpack_public_path__ + "static/media/AddData.22048487.svg";